import { WebhookEventsEnum } from '../enums';

export interface IWebhookInputDto {
    name: string;
    url: string;
    description?: string;
    secret?: string;
    events: WebhookEventsEnum[];
    enabled: boolean;
}
